module.exports = __webpack_public_path__ + "img/riskArea_checked.dc2ffb4a.png";